<script>
	import QrCode from 'svelte-qrcode';
	import {onMount, tick} from 'svelte';

	const bookListUrl = "https://afoo.me/books.html";
	const urlParams = new URLSearchParams(window.location.search);
	const books = new Map();

	const deepThinkingBook = {
		id: "thk",
		cover: "https://afoo.me/images/book_cover_way_of_deep_thinking.jpg",
		title: `《深度思考揭秘》`,
		description: `思考是人类的底层操作系统，如何深度思考决定了人与人之间的认知差异，《深度思考揭秘》带你一起揭开深度思考的奥秘！`,
		paymentUrl: bookListUrl,
		price: `102.4元`
	}

	const mgtBook = {
		id: "mgt",
		cover: "https://afoo.me/images/book_cover_mgt_class.jpg",
		title: "《极简管理课》",
		description: `大道易得，小术难求， 管理之道也是如此， 所有别人所谈之观点只能作为参考，实际情况依然需要根据自身所处企业与团队的环境与文化进行适配和调整。

管理的道理就那么多， 所以简单了解就好。

管理的套路也差不多，所以简单调整适配就好。

管理的观点说多也多， 所以收敛沉淀出自己的管理心法与策略最好！`,
		paymentUrl: bookListUrl,
		price: `102.4元`
	}
	const fuyuPamphlet = {
		id: "fuyu",
		cover: "https://afoo.me/images/%E7%A6%8F%E9%B1%BC%E7%94%BB%E5%86%8C.007.jpg",
		title: "《福鱼画册》",
		description: "一本凝聚人生智慧的精美画册",
		paymentUrl: bookListUrl,
		price: `102.4元`
	}

	const tekBizBook = {
		id: "tbh",
		cover: "https://afoo.me/images/cover_of_tek_commerce_and_human_beings.jpg",
		title: "《技术、商业与人》",
		description: "技术直达本质， 商业真接底气，一切皆为人用",
		paymentUrl: "https://mbd.pub/nocode_pay?id=a1pQZGMxNkJZQWEreCtwUEUvQlBsZz09",
		price: `102.4元`
	}

	books.set(deepThinkingBook.id, deepThinkingBook);
	books.set(mgtBook.id, mgtBook);
	books.set(fuyuPamphlet.id,fuyuPamphlet);
	books.set(tekBizBook.id,tekBizBook);

	let id = urlParams.get("id");
	let book;
	let email = "";
	let disabledEmail;
	let qrcode;
	let qrcodeVis="hidden";

	let enabledClass;
	let disabledButton=true;

	$: {
		if(!id || id == "" || qrcodeVis=="visible") {
			disabledEmail = true; 
		}else {
			disabledEmail = false;
		}

		if(disabledEmail || !email || email =="" || qrcodeVis=="visible") {
			disabledButton = true;
		}else{
			disabledButton = false;
		}

		if (disabledButton) {
            enabledClass = ""
        } else {
            enabledClass = "hover:bg-red-600 hover:text-white";
        }

		if(books.has(id)) {
			book = books.get(id);
		}else{
			// window.location.replace("https://afoo.me/books.html");
			window.location.href = "https://afoo.me/books.html";
		}
	}

	onMount(() => {
		
    });

	function refreshQrcode() {
		// let params = new URLSearchParams();

		let url = new URL(book.paymentUrl);
		let params = url.searchParams;
		params.append("product", book.title)
		params.append("email", email);
		qrcode = url.toString();
		// qrcode = book.paymentUrl + params.toString()
		qrcodeVis = "visible";
	}
</script>

<svelte:head>
    <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/tailwindcss@2.1.0/dist/tailwind.min.css"
    />
</svelte:head>

<!--把海报的layout搬过来，左右换个位置即可-->

<main>
	<h1><a href="https://afoo.me/books.html">福强图文</a></h1>
</main>

<div class="container px-5 py-3 mx-auto">
    <div class="lg:w-full mx-auto flex flex-wrap">

        <div class="md:w-1/2 w-full object-cover object-center rounded mt-3">
            <div class="relative">
                <div class="w-full object-cover mx-auto max-w-md">
                    <div>
                        <div class="shadow-lg mx-auto relative max-w-md group cursor-pointer">
                            <div class="overflow-hidden upload-btn-wrapper">
                                <img class="transform hover:scale-110 duration-200" src="{book.cover}" alt=""
                                     width="480" height="480" loading="lazy"/>
                            </div>
                            <div class="p-6 my-auto bg-white">
                                <p class="text-small text-gray-500 whitespace-pre-wrap">
									{book.description}
                                </p>
                            </div>
                            <div class="border-t pt-8 pb-8 text-center text-base text-gray-400 uppercase tracking-widest  group-hover:text-gray-600 bg-gray-50">
                                <span class="text-xl font-semibold text-gray-600 mt-4">{book.price}</span>
                                <br>
                                <span class="text-sm font-semibold text-gray-500 mt-4">
									{book.title}
                                </span>
                            </div>
                        </div>


                    </div>

                </div>
            </div>
        </div>

        <div class="md:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
            <div class="border p-3">
				<label class="mb-2 text-red-600 font-bold text-xl" for="namer">输入的邮件地址用来在您购买之后履约和交付，所以请务必填写：</label>
				<input type="text" bind:value={email} disabled={disabledEmail} placeholder="在这里留下自己的email地址吧~" class="p-2 w-full text-black border resize-none"/>
				<button class="mt-3 w-full inline-flex items-center justify-center p-2 font-black {enabledClass}"
				on:click={refreshQrcode} disabled={disabledButton}>
					<span>
						确认购买！
					</span>
				</button>
            </div>

			<div class="flex justify-center space-x-4 mt-3 w-full">
				<p class="h1 pt-12 pb-6 text-xl font-bold" style="visibility: {qrcodeVis};">点击二维码或者扫描二维码进行支付</p>
			</div>
			<div class="flex justify-center space-x-4">
				<div></div>
				<div id="qrcode" style="visibility: {qrcodeVis};">
					<a href="{qrcode}">
						<QrCode value={qrcode} />
					</a>
				</div>
				<div></div>
			  </div>
        </div>

    </div>

	<footer>
        <div class="mt-11 mx-auto">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAACWAAAAAYAQMAAABEalRSAAAABlBMVEX///9TU1NYzE1OAAAAAXRSTlMAQObYZgAAAOtJREFUeF7tljEKwzAMRb/J0CWgI/QKOYAh1+pUcjQfpUfw2MFEHVyDQSQmQUNM9AYNcobnh4egU+YVqhAvZSpgsfolPnSv5d0nz3vHslgUdK81RLzyvHcsi+WBNxQh4Ln8pw4Wi7skAg9mXgHMrEACXJnbHIllsbqGAtwXhnYswzFzwPWxWEPc2CexoobkHM4ZpD6s2loWiyIEEwCChIomMiMEHqgP573C9eHkc5VLWh3XsljnGVoLWVl+31bp38piTVVuihtPOAm9kcRLbrFjEvqwamtZLK5eI8sSan9rXEK0LcNFrY5oWawf59S7YSRD7eMAAAAASUVORK5CYII=" style="max-width: 100%;height: auto;" alt/>    
        </div>
        <div class="mt-6 mx-auto text-center"><a href="https://afoo.me">福强一人公司</a>版权所有。</div>
    </footer>
</div>

<style>

	main {
		text-align: center;
		padding: 1em;
		max-width: 100%;
		margin: 0 auto;
	}

	h1 {
		color: #3383F8;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>